import { useEffect } from 'react';

import { isKeyboardEventType } from '../types/event';
import { isMacOS } from '../utils/agent';

interface Modifiers {
	ctrl?: boolean;
	meta?: boolean;
}

const normalizeModifiers = (modifiers: Modifiers): Modifiers => ({
	...modifiers,
	...(!isMacOS() &&
		modifiers.meta && {
			ctrl: true,
			meta: false,
		}),
});

const areModifiersPressed = (e: KeyboardEvent, modifiers: Modifiers): boolean =>
	Object.entries(normalizeModifiers(modifiers)).every(([name, isOn]) => !isOn || e[`${name}Key` as keyof KeyboardEvent]);

export const useKeyboardTrigger = (key: string, handler: VoidFunction, modifiers: Modifiers) => {
	useEffect(() => {
		const onPressKey = (e: Event) => {
			/* istanbul ignore if - Unable to test, function is only a typeguard to work with diff between React and DOM types */
			if (!isKeyboardEventType(e)) {
				return;
			}

			if (key !== e.key) {
				return;
			}

			if (!areModifiersPressed(e, modifiers)) {
				return;
			}

			handler();
		};

		window.addEventListener('keydown', onPressKey);

		return () => window.removeEventListener('keydown', onPressKey);
	}, [handler, key, modifiers]);
};
